<template>
  <tr>
    <td>{{ name }}</td>
    <td>
      <span class="text-primary cursor--pointer" @click="show">
        <i class="fa fa-info-circle"></i> {{ articleName }}
      </span>
    </td>
    <td v-if="false && printArticle" class="text-right">
      {{ $filters.formatMoney(printArticle.print_inclusive ? 0.00 : printArticle.exhibitionPrices.price_net) }}
    </td>
    <td v-if="configuration.is_logo_print">
      <span v-if="configuration.file">
        {{ configuration.file.original_name}}
      </span>
      <span v-else>
        <i>{{ $t('configurator.labels.upload_missing') }}</i>
      </span>
    </td>
    <td v-else>
      {{  configuration.label }}
    </td>
    <td>
      <span class="text-primary cursor--pointer" @click="deleteConfiguration">
        <i class="fa fa-trash"></i> {{ $t('configurator.buttons.delete') }}
      </span>
    </td>
  </tr>
</template>

<script setup>
import { computed } from 'vue'
import { useMainStore } from '@/store'

const store = useMainStore()
// define props
const props = defineProps({
  configuration: {
    type: Object,
    required: true
  }
})
// define emits
const emit = defineEmits(['show'])
// define computed props
const locale = computed(() => store.settings.locale)
const shoppingCart = computed(() => store.settings.shopping_cart)

const inEnglish = computed(() => {
  return locale.value === 'en'
})

const name = computed(() => {
  return (inEnglish.value)
    ? props.configuration.booth_refinement.name_en
    : props.configuration.booth_refinement.name
})

const printArticle = computed(() => {
  const index = shoppingCart.value.print_items.findIndex((article) => {
    return article.booth_refinement_id === props.configuration.id
  })

  if (index > -1) {
    return shoppingCart.value.print_items[index]
  }

  return null
})

const articleName = computed(() => {
  if (printArticle.value === null) {
    return ''
  }

  return (inEnglish.value)
    ? printArticle.value.name_en + (printArticle.print_inclusive ? ' (inclusive)' : '')
    : printArticle.value.name + (printArticle.print_inclusive ? ' (inklusive)' : '')
})
// define methods
const deleteConfiguration = () => {
  shoppingCart.value.removeBoothConfiguration(props.configuration.id)
  shoppingCart.value.removeBoothRefinementArticle(props.configuration.booth_refinement.id)
}

const show = () => {
  emit('show', printArticle.value)
}
</script>